// @ts-nocheck
import { ValueOf } from "@store/Framework/Types/Common";

const objectValues = <T extends {}>(object: T | undefined | null) => {
    if (!object) {
        return undefined;
    }

    return Object.values(object) as Array<ValueOf<T>>;
};

export default objectValues;
